<div class="questContent" >
  <!-- 下载pdf -->
  <div class="downloadPDF" (click)="getHrefDownloadPdf()">{{i18n.t("js.check-lists.pdf.downloadPDF")}}</div>
  <!-- <div class="downloadPDF"><a [href]="getHref()">{{i18n.t("js.check-lists.pdf.downloadPDF")}}</a></div> -->
  <div class="title">
    <div class="bockicon" (click)='cleon()'></div>
    <div class="title-state" *ngIf="data.check_list.state == 'pending'">{{ i18n.t("js.check-lists.quest.Notstarted") }}</div>
    <div class="title-state" *ngIf="data.check_list.state == 'processing'" style="background-color: #ffa600">{{ i18n.t("js.check-lists.quest.Inprogress") }}</div>
    <div class="title-state" *ngIf="data.check_list.state == 'finished'" style="background-color: #087cd9;">{{ i18n.t("js.check-lists.quest.Completed") }}</div>
    <div class="title-input">
      <input #editableTitleInput
          type="p"
          [(ngModel)]="data.check_list.name"
          class="editable-toolbar-title--input toolbar--editable-toolbar ellipsis" style="width: 100%;"/>
    </div>
    <div class="groupName"  *ngIf="showHandle()">
        {{data.check_list.executor?data.check_list.executor.firstname + ' ' + data.check_list.executor.lastname:''}}
    </div>
    <div class="groupHandle" *ngIf="showHandle()" (click)="handleClick()">
      {{!isHandle() ? 'I Handle': 'Release'}}
    </div>
  </div>
</div>

<div class="content" *ngIf="showPdfdownload">
  <div class="content-date">
    <i class="asideShow" (click)="asideClick(true)">>></i>
    <i class="icon-close  asideHide"  (click)="asideClick(false)"></i>
    <div class="content-date-left">
      <div class="content-date-left-title">
        <svg t="1590741643954" class="icon" viewBox="0 0 1152 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5392" width="20" height="20">
          <path d="M0 0h1152v128H0V0z m0 448h768v128H0V448z m0 448h1152v128H0v-128z" p-id="5393" fill="#848c91"></path>
        </svg>
        <span>{{ i18n.t("js.check-lists.quest.outtline") }}</span>
      </div>
      <ul>
        <li *ngFor="let item of data.check_list.check_list_metum.parts;let i = index" (click)="clickLi(i)" (mouseover)="showAftername(i)" (mouseout)="hideAftername(i)">
          <div class="content-date-left-item " [class.btcontent-date-left-item]="num == i && dipsle"  (click)="asideClick(false)">
            <span class="shuliang"  [class.btname]="num == i && dipsle">{{i+1}}</span>
            <span class="name" [class.btname]="num == i && dipsle" style="width: 175px; margin: 0 30px 0 20px; text-align: left;">{{item.title}}</span>
            <span class="aftername">{{item.title}}</span>
            <span class="shuliang">{{item.count}}/{{getCount(item.items)}}</span>
          </div>
        </li>
        <hr />
        <li>
          <div class="content-date-left-item "  [class.btcontent-date-left-item]="!dipsle" (click)="clickSign(false)">
            <!-- <span class="shuliang "  [class.btname]="!dipsle">1</span> -->
            <span class="name "  [class.btname]="!dipsle" style="width: 175px; margin: 0 30px 0 20px; text-align: left;">{{ i18n.t("js.check-lists.quest.Required") }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="content-date-conter" >
      <ng-container *ngIf="dipsle">
        <div class="content-data-conter-title">
          <div class="content-data-cinter-title-text">
            <h2 style="margin-right: 20px;">{{num+1}}</h2>
            <h2>{{data.check_list.check_list_metum.parts[num].title}}</h2>
          </div>
          <div class="jingdutiao">
            <span class="jiangdutiao-text">{{data.check_list.check_list_metum.parts[num].count}}/{{getCount(data.check_list.check_list_metum.parts[num].items)}} {{ i18n.t("js.check-lists.quest.Signed") }}</span>
            <span class="jingdutiao-progress-bar">
              <span class="jingdutiao-install-bar"  [style.width.%]="data.check_list.check_list_metum.parts[num].count/getCount(data.check_list.check_list_metum.parts[num].items)*100"></span>
            </span>
          </div>
        </div>
        <!-- <div class="all" *ngIf="this.data.check_list.state !== 'Closed'" (click)="allLogShow()">
          All
          <div class="allLog" (click)="$event.stopPropagation()" *ngIf="allLog">
            Select All
            <span class="point"></span>
            <div class="check">
              <span>Yes</span>
              <input type="radio"
              value="1"
              [(ngModel)]="checkYes"
              (ngModelChange)="check(0)"
              />
            </div>
            <div class="check">
              <span>
                No
              </span>
              <input
              type="radio"
              value="0"
              [(ngModel)]="checkYes"
              (ngModelChange)="check(1)"
              />
            </div>
            <div class="check">
              <span>
                N/A
              </span>
              <input
              type="radio"
              value="2"
              [(ngModel)]="checkYes"
              (ngModelChange)="check(2)"
              />
            </div>
          </div>
        </div> -->
        <div class="content-date-conter-describe">
          <pre style="padding-bottom: 8px;font-size: 13px;">{{data.check_list.check_list_metum.parts[num].description}}</pre>
        </div>
        <div class="content-date-conter-item" *ngFor="let item of data.check_list.check_list_metum.parts[num].items;let i = index">
          <div class="Dropzone">
            <span class="SectionItem__index">{{num+1}}.{{i+1}}</span>
            <!--*********************************开始的地方***********************************************-->
            <ul class="dropZoneUl">
              <li *ngFor="let subitem of item.list;let subindex=index" class="zoneLi">
                <div class="SectionItem__content" style="width: 100%;">

                  <div class="SectionItem__content-field">  <span class="wrapspan">{{subitem.title}} </span>  <i *ngIf="subitem.necessary===false" style="color: 84969e;margin-left: 10px;">({{ i18n.t("js.check-lists.template.optional") }})</i></div>
                  <div class="SectionItem__instructions">
                    <div class="SectionItem__instructions-title" *ngIf="subitem.description">{{ i18n.t("js.check-lists.quest.Description") }}:</div>
                    <div class="SectionItem__instructions-text">{{subitem.description}}</div>
                  </div>
                  <input class="SectionItem__response-text-editable" [id]="'input_getinfo'+i+subindex" [disabled]="checkDisable()"  *ngIf="subitem.type == 'text'"  (click)="input_getinfoInputChange(i,subindex)"  (blur)="updateUserInfo($event,i,subindex)"   [(ngModel)]="subitem.value"  type="text"/>
                  <span  *ngIf="subitem.type == 'radio'">
                    <span  *ngFor="let t of subitem.options;let j = index" style="margin-left: 30px;">
                      <input style="vertical-align: middle;width: 20px; height: 20px;" [disabled]="checkDisable()"  (ngModelChange)="changeSelect($event,j,i,subindex)" [checked]="j === subitem.value"  [type]="subitem.type" [(ngModel)]="t" />
                      <span style="margin-left: 10px;">{{t}}</span>
                    </span>
                  </span>
                  <input class="SectionItem__response-text-editable" [id]="'input_getinfo'+i+subindex" [disabled]="checkDisable()"  *ngIf="subitem.type == 'Int'"  (click)="input_getinfoInputChange(i,subindex)"  (blur)="updateUserInfo($event,i,subindex)" (keyup)="changeNumberToInt(subitem, $event)"   [(ngModel)]="subitem.value"  type="number"/>
                  <input class="SectionItem__response-text-editable" [id]="'input_getinfo'+i+subindex" [disabled]="checkDisable()"  *ngIf="subitem.type == 'Number'"  (click)="input_getinfoInputChange(i,subindex)"  (blur)="updateUserInfo($event,i,subindex)" (change)="changeNaNReturnZero(subitem, $event)"   [(ngModel)]="subitem.value"  type="number"/>
                  <input class="SectionItem__response-text-editable" [id]="'input_getinfo'+i+subindex" [disabled]="true"
                    *ngIf="subitem.type == 'unique_date'"   [(ngModel)]="data.check_list.unique_date"  type="text"/>
                  <span *ngIf="subitem.type == 'textarea'">
                      <textarea class="textareaContent" [disabled]="checkDisable()" (click)="input_getinfoInputChange(i,subindex)"  (blur)="updateUserInfo($event,i,subindex)" [(ngModel)]="subitem.value">

                      </textarea>
                  </span>
                  <span  *ngIf="subitem.type == 'checkbox'">
                    <span  *ngFor="let t of subitem.options; let j = index" style="margin-left: 30px;display: block;margin-bottom: 10px;">
                        <input style="vertical-align: middle;width: 20px; height: 20px;" [disabled]="checkDisable()" [type]="subitem.type"  (change)="changeCheckbox($event,j,i,subindex,subitem)"  [(ngModel)]="j"   [checked]="subitem.value.includes(j)" />
                        <span style="margin-left: 10px;">{{t}}</span>
                    </span>
                  </span>
                  <!--另外的情况-->
                  <div *ngIf="subitem.type=='date'">
                    <!-- <input type="date"  [(ngModel)]="subitem.value"  (blur)="changeDate($event,i,subindex)"> -->
                    <div class="summary-value" [id]="'period_end'+i+subindex" style="width: 250px;height: 38px;border: 1px solid #bbb;"  (click)="subitem.type = 'null' ; subitem.type = 'date';period_endChange(subitem.value,i,subindex,subitem)">{{subitem.value}}</div>
                  </div>

                  <div *ngIf="subitem.type =='select'">
                    <select [disabled]="checkDisable()" style="width: 250px;line-height: unset;" [(ngModel)]="subitem.value" style="width: 250px;line-height: unset;" (click)="input_getinfoInputChange(i,subindex)" (change)="newSelect($event,i,subindex)">
                      <option [value]="optionitem" *ngFor="let optionitem of subitem.options">{{optionitem}}</option>
                    </select>
                  </div>
                  <div *ngIf="subitem.type =='radio_sign_date'">
                    <div>
                      <span  *ngFor="let t of subitem.options;let j = index" style="margin-left: 30px;">
                      <input style="vertical-align: middle;width: 20px; height: 20px;" [disabled]="checkDisable()"  (ngModelChange)="changeSelect($event,j,i,subindex)" [checked]="j === subitem.value"  [type]="'radio'" [(ngModel)]="t" />
                      <span style="margin-left: 10px;">{{t}}</span>
                    </span>
                    </div>
                    <div >
                      <div class="flex-box">
                        <div class="summary-value" [id]="'period_end'+i+subindex" style="width: 250px;height: 38px;border: 1px solid #bbb;"  (click)="period_endChange(subitem.sign_date,i,subindex,subitem)">{{subitem.sign_date}}</div>
<!--                        <button class="sign_btn" (click)="signBox(i,subindex,subitem)" >SIGN IN</button>-->
                      </div>
                      <div class="action">
                        <div class='attributes-key-value--value-container'
                             [ngClass]="{'canNotSign':!(data.check_list.state == 'New' ||  data.check_list.recheck == 'recheck')}"
                             style="display: flex; flex-direction: column;">
<!--                          <span>{{data.check_list.created_by_user + '(' + data.check_list.created_by_position + ')' }}  Sign</span>-->
                          <!-- handler 下拉框下面的文字 -->
                          <span style="margin: 10px 0;" ></span>
                          <div class="attributes-key-value--value-container-content"
                               *ngIf="!subitem.sign_id && !signloding"
                               (click)="signBox(i,subindex,subitem)"
                          >
                            <div class="attributes-key-value--value-container-content-icon"
                            >
                              <span class="icon-add" style="color: #fff;"></span>
                            </div>
                          </div>
                          <div class="attributes-key-value__loading" *ngIf="signloding">
                            <div class="loading-indicator -compact">
                              <div class="block-1"></div>
                              <div class="block-2"></div>
                              <div class="block-3"></div>
                              <div class="block-4"></div>
                              <div class="block-5"></div>
                            </div>
                          </div>
                          <div class="deleteSign" *ngIf="kind_id == 12 &&  subitem.sign_id && (data.check_list.state == 'New' ||  data.check_list.recheck == 'recheck' )" (click)="deleteSignBox(i,subindex)" >X</div>

                          <img class="signImg"  [src]='imageSrc(subitem)' *ngIf="subitem.sign_id"/>
<!--                          <div>-->
<!--                            <input type="checkbox" [(ngModel)]="actionCheckBoolean" *ngIf="checkSign('action')" (change)="defaultCheck('action', $event)"/> 默认签名-->
<!--                          </div>-->
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
              </li>
            </ul>
        <!--*********************************结束的地方***************************-->
          </div>
          <div class="ChecklistItemAddAttachmentsStrip">
            <!-- <button class="Button--link-secondary" (click)="issueblock = true">
              <svg t="1590993757327" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2635" width="17" height="17"><path d="M950.784 812.544L567.296 147.968c-24.576-42.496-86.016-42.496-110.08 0l-384 664.576c-24.576 42.496 6.144 95.744 55.296 95.744h766.976c49.152-0.512 79.872-53.248 55.296-95.744zM482.816 391.68c0-16.384 13.312-29.184 29.184-29.184 16.384 0 29.184 13.312 29.184 29.184v297.984c0 16.384-13.312 29.184-29.184 29.184-16.384 0-29.184-13.312-29.184-29.184V391.68z m29.184 420.352c-16.384 0-30.208-13.312-30.208-30.208 0-16.384 13.312-30.208 30.208-30.208 16.384 0 30.208 13.312 30.208 30.208 0 16.896-13.824 30.208-30.208 30.208z" fill="#819099" p-id="2636"></path></svg>
              <span class="ChecklistItemAddAttachmentsStrip__button-text">{{ i18n.t("js.check-lists.quest.Issue") }}</span>
            </button> -->
            <button class="Button--link-secondary" (click)="showNote(item,i)">
              <svg t="1590994468040" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3528" width="17" height="17"><path d="M600.76158 68.191078 245.714238 68.191078c-49.040926 0-88.317465 39.720653-88.317465 88.76158l-0.444115 710.09366c0 49.040926 39.277562 88.76158 88.317465 88.76158l533.014616 0c49.040926 0 88.76158-39.720653 88.76158-88.76158L867.046319 334.476841 600.76158 68.191078zM689.523159 778.284739 334.475817 778.284739l0-88.76158 355.047342 0L689.523159 778.284739zM689.523159 600.76158 334.475817 600.76158l0-88.76158 355.047342 0L689.523159 600.76158zM556.38079 378.857631 556.38079 134.762263 800.475134 378.857631 556.38079 378.857631z" p-id="3529" fill="#819099"></path></svg>
              <span class="ChecklistItemAddAttachmentsStrip__button-text">{{ i18n.t("js.check-lists.quest.note") }}</span>
            </button>
            <button class="Button--link-secondary" (click)="uploadImg(item,i)">
              <svg t="1590994558068" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4505" width="17" height="17"><path d="M512.000512 344.135828c-100.70868 0-182.350095 81.640392-182.350095 182.348048s81.641415 182.349071 182.350095 182.349071c100.70561 0 182.348048-81.641415 182.348048-182.349071S612.706121 344.135828 512.000512 344.135828z" p-id="4506" fill="#819099"></path><path d="M879.229291 229.637074 754.566036 229.637074l-75.05951-83.400478L341.665055 146.236596l-72.67623 83.400478-124.219139 0c-44.26004 0-80.139202 36.56273-80.139202 81.669044l0 484.787218c0 45.105291 35.879162 81.669044 80.139202 81.669044l734.459604 0c44.262086 0 80.139202-36.56273 80.139202-81.669044L959.368492 311.306118C959.369515 266.200828 923.491377 229.637074 879.229291 229.637074zM512.000512 799.301402c-150.673651 0-272.817526-122.143874-272.817526-272.817526 0-150.671605 122.143874-272.816502 272.817526-272.816502 150.671605 0 272.815479 122.143874 272.815479 272.816502C784.814967 677.157527 662.672116 799.301402 512.000512 799.301402z" p-id="4507" fill="#819099"></path></svg>
              <span class="ChecklistItemAddAttachmentsStrip__button-text">{{ i18n.t("js.check-lists.quest.photo") }}</span>
              <div (click)="service.stopPropagation($event)" style="display: none;">
                <input #uploadFileRef type="file" (change)="selectFile($event,item,i)">
              </div>
            </button>
            <button class="Button--link-secondary" (click)="uploadPdf(item,i)">
              <svg t="1698736239732" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3508" width="17" height="17"><path d="M499.2 507.733333c-17.066667 34.133333-29.866667 68.266667-46.933333 98.133334h4.266666v4.266666c29.866667-12.8 64-21.333333 98.133334-29.866666-21.333333-25.6-42.666667-51.2-55.466667-72.533334zM486.4 298.666667h-8.533333c-4.266667 25.6 0 51.2 8.533333 72.533333 8.533333-21.333333 8.533333-46.933333 0-72.533333zM298.666667 725.333333c25.6-8.533333 38.4-21.333333 51.2-42.666666-21.333333 12.8-38.4 25.6-51.2 42.666666zM691.2 580.266667c-12.8 0-25.6 0-38.4 4.266666 12.8 8.533333 29.866667 8.533333 42.666667 12.8 8.533333 0 21.333333 0 29.866666-4.266666 0-4.266667-4.266667-12.8-34.133333-12.8z" p-id="3509" fill="#8a8a8a"></path><path d="M827.733333 315.733333l-204.8-204.8c-17.066667-17.066667-38.4-25.6-59.733333-25.6H213.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667v768c0 25.6 17.066667 42.666667 42.666666 42.666667h597.333334c25.6 0 42.666667-17.066667 42.666666-42.666667V375.466667c0-21.333333-8.533333-42.666667-25.6-59.733334zM695.466667 640c-38.4-4.266667-76.8-17.066667-106.666667-42.666667-59.733333 12.8-115.2 29.866667-170.666667 55.466667-42.666667 76.8-85.333333 119.466667-119.466666 119.466667-8.533333 0-17.066667 0-21.333334-4.266667-12.8-12.8-21.333333-29.866667-21.333333-42.666667s4.266667-46.933333 136.533333-106.666666c29.866667-55.466667 55.466667-115.2 76.8-174.933334-17.066667-34.133333-55.466667-119.466667-29.866666-162.133333 8.533333-17.066667 25.6-25.6 42.666666-21.333333 12.8 0 29.866667 8.533333 38.4 17.066666 17.066667 25.6 17.066667 81.066667-8.533333 157.866667 21.333333 42.666667 51.2 81.066667 89.6 115.2 29.866667-4.266667 59.733333-8.533333 89.6-8.533333 68.266667 0 76.8 34.133333 76.8 51.2 0 46.933333-46.933333 46.933333-72.533333 46.933333z" p-id="3510" fill="#8a8a8a"></path></svg>
              <span class="ChecklistItemAddAttachmentsStrip__button-text">PDF</span>
              <div (click)="service.stopPropagation($event)" style="display: none;">
                <input #uploadPdfFileRef type="file" (change)="selectPdfFile($event,item,i)">
              </div>
            </button>
          </div>


          <!-- 注释 ----------------------------------------------------------------------->
            <div class="ChecklistSectionItemAttachments__attachments" *ngIf="(checkObj(item.props)||((remark_id==i)&&remarkFlag))">
            <div class="ChecklistSectionItemAttachments__attachment-component">
              <div class="ChecklistItemPhotos__avatar-container">
                <div class="UserAvatar">
                  <div class="UserAvatar__initials-text">SW</div>
                </div>
              </div>
              <!-- picture -->
              <div *ngIf="item.props.image">
                <div class="ChecklistItemPhotos__thumbnail-strip" *ngIf="item.props.image.length">
                <div class="ThumbnailPicture__image-container viewDiv" *ngFor="let img of item.props.image;let k = index">
                  <img   [src]="host+'/api/v3/logical_docs/doc/'+img.doc_id+'/stream'"/>
                  <span style="margin-left:8px">{{img.status}}</span>
                  <div style="width: 70px;height: 70px;position: absolute;top: 0;" (click)="toEditpic(k,item.props.image,img,i)"></div>
                </div>
              </div>
            </div>
             <!--pdf-->
             <div *ngIf="item.props.pdf">
              <div class="ChecklistItemPhotos__thumbnail-strip" *ngIf="item.props.pdf.length">
                <div class="ThumbnailPicture__image-container viewDiv" *ngFor="let pdf of item.props.pdf;let k = index">
                  <svg t="1698744607816" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2358" width="70" height="70"><path d="M160 32c-12 0-24.8 4.8-33.6 14.4S112 68 112 80v864c0 12 4.8 24.8 14.4 33.6 9.6 9.6 21.6 14.4 33.6 14.4h704c12 0 24.8-4.8 33.6-14.4 9.6-9.6 14.4-21.6 14.4-33.6V304L640 32H160z" fill="#FF5562" p-id="2359"></path><path d="M912 304H688c-12 0-24.8-4.8-33.6-14.4-9.6-8.8-14.4-21.6-14.4-33.6V32l272 272z" fill="#FFBBC0" p-id="2360"></path><path d="M696 843.2c-50.4 0-95.2-86.4-119.2-142.4-40-16.8-84-32-126.4-42.4-37.6 24.8-100.8 61.6-149.6 61.6-30.4 0-52-15.2-60-41.6-6.4-21.6-0.8-36.8 5.6-44.8 12.8-17.6 39.2-26.4 79.2-26.4 32 0 72.8 5.6 118.4 16.8 29.6-20.8 59.2-44.8 85.6-70.4-12-56-24.8-146.4 8-188 16-20 40.8-26.4 70.4-17.6 32.8 9.6 44.8 29.6 48.8 44.8 13.6 54.4-48.8 128-91.2 171.2 9.6 37.6 21.6 76.8 36.8 112.8C663.2 704 735.2 744 743.2 788c3.2 15.2-1.6 29.6-13.6 41.6-10.4 8.8-21.6 13.6-33.6 13.6z m-74.4-121.6c30.4 61.6 59.2 90.4 74.4 90.4 2.4 0 5.6-0.8 10.4-4.8 5.6-5.6 5.6-9.6 4.8-12.8-3.2-16-28.8-42.4-89.6-72.8z m-296-82.4c-39.2 0-50.4 9.6-53.6 13.6-0.8 1.6-4 5.6-0.8 16.8 2.4 9.6 8.8 19.2 29.6 19.2 25.6 0 62.4-14.4 105.6-40-31.2-6.4-58.4-9.6-80.8-9.6z m158.4-4.8c25.6 7.2 52 16 76.8 25.6-8.8-23.2-16-47.2-22.4-70.4-17.6 15.2-36 30.4-54.4 44.8zM583.2 376c-8.8 0-15.2 3.2-20.8 9.6-16.8 20.8-18.4 73.6-5.6 140.8 48.8-52 75.2-100 68.8-125.6-0.8-4-4-15.2-26.4-21.6-6.4-2.4-11.2-3.2-16-3.2z" fill="#FFFFFF" p-id="2361"></path></svg>
                  <span style="margin-left:8px">{{pdf.status}}</span>
                  <div style="width: 70px;height: 70px;position: absolute;top: 0;" (click)="openPdf(k,item.props.pdf,pdf,i)"></div>
                  <div class="removePdf" (click)="removePdf(k,item.props.pdf,pdf,i)">remove</div>
                </div>
              </div>
            </div>
              <!-- <div class="ChecklistItemPhotos__thumbnail-strip" *ngIf="!item.props.image.length&&doc_item_id!=i">
                <div class="ThumbnailPicture__image-container viewDiv" *ngFor="let img of item.props.image;let k = index">
                  <img  [src]="host+'/api/v3/logical_docs/doc/'+img.doc_id+'/stream'"/>
                  <span style="margin-left:8px">{{img.status}}</span>
                  456789
                  <div style="width: 70px;height: 70px;position: absolute;top: 0;" (click)="toEditpic(k,item.props.image,img,i)"></div>
                </div>
              </div>
              <div class="ChecklistItemPhotos__thumbnail-strip" *ngIf="!item.props.image.length&&doc_item_id==i">
                <div class="ThumbnailPicture__image-container viewDiv" *ngFor="let img of templateid;let k = index">
                  <img  [src]="host+'/api/v3/logical_docs/doc/'+img.doc_id+'/stream'"/>
                  <span style="margin-left:8px">{{img.status}}</span>
                  789123
                  <div style="width: 70px;height: 70px;position: absolute;top: 0;" (click)="toEditpic(k,item.props.image,img,i)"></div>
                </div>
              </div> -->
            </div>
            <div class="ChecklistSectionItemAttachments__attachment-component" *ngIf="((remark_id==i)&&remarkFlag)||item.props.remark">
              <div class="ChecklistItemNote__well">
                <div class="TextInput__editable">
                  <input type="text" [(ngModel)]="item.props.remark" [disabled]="checkDisable()"  #nameit  (blur)="addRemark($event,i)" placeholder="Add comments" />
                </div>
              </div>
            </div>
          </div>
          <!-- -------------------------------------------------------------------- -->
        </div>
        <div class="CompleteSelectedSection">
          <button class="SaveButton__save-button" *ngIf="data.check_list.check_list_metum.parts[num].state != 'finished'"  (click)="wanchengpardclick(data.check_list.check_list_metum.parts[num].items)">{{ i18n.t("js.check-lists.quest.done") }}</button>
          <span style="color: #008a00;" class="CompleteSelectedSection__items-remaining"  *ngIf="data.check_list.check_list_metum.parts[num].state != 'finished'">
            {{needNum==0? i18n.t("js.check-lists.quest.requiredquanbu"):(hascount) +i18n.t("js.check-lists.quest.requiredidex")}}
            <span *ngIf="showNum">({{needNum}}{{i18n.t("js.check-lists.template.required")}})</span>
          </span>
          <span  style="color: #008a00;" class="CompleteSelectedSection__items-remaining"   *ngIf="data.check_list.check_list_metum.parts[num].state == 'finished'">
            {{i18n.t("js.check-lists.quest.requiredquanbu")}}
          </span>
        </div>

      </ng-container>
      <ng-container *ngIf="!dipsle">
        <!-- 签名 -->
        <div class="content-data-conter-title">
          <div class="content-data-cinter-title-text">
            <!-- <h2 style="margin-right: 20px;">1</h2> -->
            <h2>{{i18n.t("js.check-lists.quest.Required")}}</h2>
          </div>
        </div>
          <!-- 第一个签名 -->
        <div *ngFor="let item of CurrentData;let i = index">
            <ng-container *ngIf="item.isShowBox">
                <div class="require" >
                  <div>{{item.RequiredText}}</div>
                  <textarea   [(ngModel)]="item.remark" [disabled]="item.disabled?'false':'disabled'"> </textarea>
                  <check-field-dateTime id="item.dateTime" [value]="item.dateTime" (changeValue)="changeSign(item.timeType,$event,i)" [ngClass]="{'DateDisabled': !item.disabled}" ></check-field-dateTime>
                  <div *ngIf="!item.disabled">
                    {{item.dateTime}}
                  </div>
                  <!-- 复查备注历史 -->
                  <div *ngIf="item.recheck_remark_logs && item.recheck_remark_logs.length > 0" class="recheck-logs">
                    <div *ngFor="let log of item.recheck_remark_logs" class="recheck-log-item">
                      <span class="recheck-log-time">{{log.remark_at}}</span>
                      <span class="recheck-log-remark">{{log.remark}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <span>{{ item.userName }}  Sign</span>
                  <span style="margin: 10px 0;" ></span>
                  <div class="is_satisfaction_box" *ngIf="i == 2 && kind_id == 4">
                    <div class="showBox">
                      <div>The Conractor's performance on nuisance abatement and waste mamagement *is / is not to the satisfactionof the Supervisor's nominated site representativeat the time of inspection. ( * delete as appropriate)</div>
                      <div>
                        <select [disabled]="!item.disabled" [(ngModel)]="item.is_satisfaction" style="width: 250px; padding: 5px; margin-top: 10px;">
                          <option [value]="0">is not</option>
                          <option [value]="1">is</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">

                  <div class='attributes-key-value--value-container'
                  [ngClass]="{'canNotSign': !item.disabled}"
                  style="display: flex; flex-direction: column;">


                    <div class="attributes-key-value--value-container-content"
                      *ngIf="!item.img && !item.signloding"
                      (click)="displaysign(i)"
                      >
                      <div class="attributes-key-value--value-container-content-icon"
                      >
                        <span class="icon-add" style="color: #fff;"></span>
                      </div>
                    </div>
                    <div class="attributes-key-value__loading" *ngIf="item.signloding">
                      <div class="loading-indicator -compact">
                      <div class="block-1"></div>
                      <div class="block-2"></div>
                      <div class="block-3"></div>
                      <div class="block-4"></div>
                      <div class="block-5"></div>
                      </div>
                    </div>
                    <div class="deleteSign" *ngIf="item.img && item.disabled" (click)="deleteSign(i)" >X</div>

                    <img class="signImg"  [src]='item.img' *ngIf="item.img"/>
                    <div>
                      <input type="checkbox" *ngIf="item.isDefaultSign" (change)="defaultCheck(i, $event)"/> {{i18n.t("js.check-lists.signature")}}
                    </div>
                  </div>
                </div>
             </ng-container>
        </div>
        <!-- 第2个签名 -->
        <!-- <div *ngIf="showSignBox(2)">
          <div class="require" >
            <div>Reply</div>
            <textarea   [(ngModel)]="data.check_list.reply" [disabled]="secondRequirBoolean()?'disabled': false"> </textarea>
            <check-field-dateTime id="data.check_list.inspection_first_sign_at" [value]="data.check_list.inspection_first_sign_at" (changeValue)="changeSign('inspection_first_sign_at',$event)" [ngClass]="{'DateDisabled': secondRequirBoolean()}" ></check-field-dateTime>
            <div *ngIf="secondRequirBoolean()">
              {{data.check_list.inspection_first_sign_at}}
            </div>
          </div>
         <div class="action">
           <div class='attributes-key-value--value-container'
           [ngClass]="{'canNotSign': !canNotSignsecond()}"
           style="display: flex; flex-direction: column;">
           <span  *ngIf=" data.check_list.state != 'Recheck'">{{data.check_list.assigned_to.firstname + ' ' + data.check_list.assigned_to.lastname + '(' + data.check_list.assigned_to.position + ')'}} Sign</span>
             <span style="margin: 10px 0;" ></span>
             <div class="attributes-key-value--value-container-content"
               *ngIf="!secondSign && !signloding"
               (click)="displaysign('second')"
              >
               <div class="attributes-key-value--value-container-content-icon"
               >
                 <span class="icon-add" style="color: #fff;"></span>
               </div>
             </div>
             <div class="attributes-key-value__loading" *ngIf="signloding">
               <div class="loading-indicator -compact">
               <div class="block-1"></div>
               <div class="block-2"></div>
               <div class="block-3"></div>
               <div class="block-4"></div>
               <div class="block-5"></div>
               </div>
             </div>
             <div class="deleteSign" *ngIf="secondSign && ((data.check_list.assigned_to_id == userId &&(data.check_list.state == special_first_type ) ))" (click)="deletefirstSign('second')" >X</div>

             <img class="signImg"  [src]='secondSign' *ngIf="secondSign"/>
             <div>
               <input type="checkbox" *ngIf="checkSign('second')" (change)="defaultCheck('second', $event)"/> {{i18n.t("js.check-lists.signature")}}
             </div>
           </div>
         </div>
        </div> -->
        <!-- 第3个签名 -->
        <!-- <div *ngIf="showSignBox(3)">
          <div class="require" >
            <div>Reply</div>
            <textarea   [(ngModel)]="data.check_list.reply_last" [disabled]="thirdRequirBoolean()?'disabled': false"> </textarea>
            <check-field-dateTime id="data.check_list.inspection_second_sign_at" [value]="data.check_list.inspection_second_sign_at" (changeValue)="changeSign('inspection_second_sign_at',$event)" [ngClass]="{'DateDisabled': thirdRequirBoolean()}" ></check-field-dateTime>
            <div *ngIf="thirdRequirBoolean()">
              {{data.check_list.inspection_second_sign_at}}
            </div>
          </div>
         <div class="action">
           <div class='attributes-key-value--value-container'
           [ngClass]="{'canNotSign': !canNotSignthird()}"
           style="display: flex; flex-direction: column;">
           <span  *ngIf=" data.check_list.state != 'Recheck'">{{data.check_list.assigned_to_last.firstname + ' ' +
            data.check_list.assigned_to_last.lastname + '(' + data.check_list.assigned_to_last.position + ')'}} Sign</span>
             <span style="margin: 10px 0;" ></span>
             <div class="attributes-key-value--value-container-content"
               *ngIf="!thirdSign && !signloding"
               (click)="displaysign('third')"
              >
               <div class="attributes-key-value--value-container-content-icon"
               >
                 <span class="icon-add" style="color: #fff;"></span>
               </div>
             </div>
             <div class="attributes-key-value__loading" *ngIf="signloding">
               <div class="loading-indicator -compact">
               <div class="block-1"></div>
               <div class="block-2"></div>
               <div class="block-3"></div>
               <div class="block-4"></div>
               <div class="block-5"></div>
               </div>
             </div>
             <div class="deleteSign" *ngIf="thirdSign && ((data.check_list.assigned_to_last_id == userId &&(data.check_list.state == 'site agent signed' ) ))" (click)="deletefirstSign('third')" >X</div>

             <img class="signImg"  [src]='thirdSign' *ngIf="thirdSign"/>
             <div>
               <input type="checkbox" *ngIf="checkSign('third')" (change)="defaultCheck('third', $event)"/> {{i18n.t("js.check-lists.signature")}}
             </div>
           </div>
         </div>
        </div> -->
        <!-- 第4签名 -->
        <!-- <div *ngIf="showSignBox(4)">
          <div class="require" >
            <div>Reply</div>
            <textarea   [(ngModel)]="data.check_list.fourth_sign_remark" [disabled]="fourthRequirBoolean()?'disabled': false"> </textarea>
            <check-field-dateTime id="data.check_list.fourth_sign_at" [value]="data.check_list.fourth_sign_at" (changeValue)="changeSign('fourth_sign_at',$event)" [ngClass]="{'DateDisabled': fourthRequirBoolean()}" ></check-field-dateTime>
            <div *ngIf="fourthRequirBoolean()">
              {{data.check_list.fourth_sign_at}}
            </div>
          </div>
         <div class="action">
           <div class='attributes-key-value--value-container'
           [ngClass]="{'canNotSign': !canNotSignfourth()}"
           style="display: flex; flex-direction: column;">
           <span  *ngIf=" data.check_list.state != 'Recheck'">{{data.check_list.fourth_sign_user.firstname + ' ' +
            data.check_list.fourth_sign_user.lastname + '(' + data.check_list.fourth_sign_user.position + ')'}} Sign</span>
             <span style="margin: 10px 0;" ></span>
             <div class="attributes-key-value--value-container-content"
               *ngIf="!fourthSign && !signloding"
               (click)="displaysign('fourth')"
              >
               <div class="attributes-key-value--value-container-content-icon"
               >
                 <span class="icon-add" style="color: #fff;"></span>
               </div>
             </div>
             <div class="attributes-key-value__loading" *ngIf="signloding">
               <div class="loading-indicator -compact">
               <div class="block-1"></div>
               <div class="block-2"></div>
               <div class="block-3"></div>
               <div class="block-4"></div>
               <div class="block-5"></div>
               </div>
             </div>
             <div class="deleteSign" *ngIf="fourthSign && ((data.check_list.fourth_sign_user_id == userId &&(data.check_list.state == 'supervisor checked' ) ))" (click)="deletefirstSign('fourth')" >X</div>

             <img class="signImg"  [src]='fourthSign' *ngIf="fourthSign"/>
             <div>
               <input type="checkbox" *ngIf="checkSign('fourth')" (change)="defaultCheck('fourth', $event)"/> {{i18n.t("js.check-lists.signature")}}
             </div>
           </div>
         </div>
        </div> -->
         <!-- 第5签名 -->
        <!-- <div *ngIf="showSignBox(5)">
          <div class="require" >
            <div>Reply</div>
            <textarea   [(ngModel)]="data.check_list.fifth_sign_remark" [disabled]="fifthRequirBoolean()?'disabled': false"> </textarea>
            <check-field-dateTime id="data.check_list.fifth_sign_at" [value]="data.check_list.fifth_sign_at" (changeValue)="changeSign('fifth_sign_at',$event)" [ngClass]="{'DateDisabled': fifthRequirBoolean()}" ></check-field-dateTime>
            <div *ngIf="fifthRequirBoolean()">
              {{data.check_list.fifth_sign_at}}
            </div>
          </div>
         <div class="action">
           <div class='attributes-key-value--value-container'
           [ngClass]="{'canNotSign': !canNotSignfifth()}"
           style="display: flex; flex-direction: column;">
           <span  *ngIf=" data.check_list.state != 'Recheck'">{{data.check_list.fifth_sign_user.firstname + ' ' +
            data.check_list.fifth_sign_user.lastname + '(' + data.check_list.fifth_sign_user.position + ')'}} Sign</span>
             <span style="margin: 10px 0;" ></span>
             <div class="attributes-key-value--value-container-content"
               *ngIf="!fifthSign && !signloding"
               (click)="displaysign('fifth')"
              >
               <div class="attributes-key-value--value-container-content-icon"
               >
                 <span class="icon-add" style="color: #fff;"></span>
               </div>
             </div>
             <div class="attributes-key-value__loading" *ngIf="signloding">
               <div class="loading-indicator -compact">
               <div class="block-1"></div>
               <div class="block-2"></div>
               <div class="block-3"></div>
               <div class="block-4"></div>
               <div class="block-5"></div>
               </div>
             </div>
             <div class="deleteSign" *ngIf="fifthSign && ((data.check_list.fifth_sign_user_id == userId &&(data.check_list.state == 'supervisor_1 signed' ) ))" (click)="deletefirstSign('fifth')" >X</div>

             <img class="signImg"  [src]='fifthSign' *ngIf="fifthSign"/>
             <div>
               <input type="checkbox" *ngIf="checkSign('fifth')" (change)="defaultCheck('fifth', $event)"/> {{i18n.t("js.check-lists.signature")}}
             </div>
           </div>
         </div>
        </div> -->

        <div class="Button Daily">
         <p>
           <span class="checkorclose">
             <div class="recheck" *ngIf="!(data.check_list.state == 'Recheck' ||  data.check_list.state == 'Contractor Recheck' ||data.check_list.state == 'New'|| data.check_list.state == CurrentData[CurrentData.length - 1].CurrentStatus)"  (click)="AssignSave('Recheck')"
             [ngClass]="{'canNotClick':  recheckStatus()}">
               Recheck
             </div>
             <div class="closed" *ngIf="data.check_list.state == CurrentData[CurrentData.length - 2].CurrentStatus"
                  (click)="AssignSave('Closed')"
                  [ngClass]="{'canNotClick': !setpSign()}">
               Closed
             </div>
             <div class="assign"   [ngClass]="{'canNotClick': !setpSign()}"
             *ngIf="!data.check_list.state.includes(CurrentData[CurrentData.length - 1].CurrentStatus)&&!data.check_list.state.includes(CurrentData[CurrentData.length - 2].CurrentStatus)"
             (click)="showAssign()">Assign</div>
             <!-- <div class="Save" *ngIf="data.check_list.state != 'Project Manager Second Signed'"  (click)="AssignSave(data.check_list.state, true)"  [ngClass]="{'canNotClick': saveStatus()}">Save</div> -->
            </span>
         </p>
          <!-- <span class="SaveButton">

          </span> -->
        </div>
        <div *ngIf="ifCheckAssign" >
          <div class="assigngroupCheck" *ngIf="kind_id != 1">
            <div class="header">
              <div>Select an Individual or a group</div>
              <div class="close layui-layer-ico" (click)="ifCheckAssign = false;changeAssignTo('Indlvidual')"></div>
            </div>
            <div class="contentDialog">
            <div class="selectAssignType">
              <div>

                <input class="radio_type" type="radio" name="type" id="radio1" (change)="changeAssignTo('Indlvidual')" checked="checked"/>
                <label for="radio1">Individual</label>
              </div>
              <div>

                <input class="radio_type" type="radio" (change)="changeAssignTo('group')" name="type" id="radio2" />
                <label for="radio2">Group</label>
              </div>
            </div>

            <div class="searchBox">
              <input type="text" [placeholder]="assignType === 'group' ? 'Search groups...' : 'Search users...'" [(ngModel)]="searchKeyword" (input)="filterAssignList()">
            </div>

            <div class="table">
            <table>
              <thead>
                <tr>
                  <th class="assign">Assign to</th>
                  <th class="name"></th>
                  <th class="cc:">cc:</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of filteredAssignList">
                  <td>
                    <input class="checkbox_type" type="radio" name="assignId" [value]="item.id"  [(ngModel)]="constructorUserId"  />
                  </td>
                  <td class="name">
                    <div>
                       {{item.name? item.name: item.firstname + item.lastname}}
                    </div>
                    <div *ngIf="assignType == 'Indlvidual'">
                      {{item.position? item.position: '——'}}
                    </div>
                  </td>
                  <td><input class="checkbox_type" type="checkbox" [value]="item.id" name="type" [(ngModel)]="item.checked"   /> </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="assignButton">

            <div class="cancel" (click)="ifCheckAssign = false;changeAssignTo('Indlvidual')" >
              Cancel
            </div>
            <div class="confirm" (click)="AssignSave((data.check_list.state == 'Sent' && !!data.check_list.recheck == false)? 'Completed': 'Sent')" [ngClass]="{'canNotClick': !constructorUserId}">
              Confirm
            </div>
          </div>
          </div>
         </div>
        </div>

    </ng-container>
      <!-- 分页 -->
      <checkListSign *ngIf="dipslesignature" (closeView)='closeView($event)'></checkListSign>
      <div class="BaseSectionsPagination__bottom-navigation" *ngIf="dipsle">
        <div style="width: 350px;">
          <!-- 往前 -->
          <div class="BaseSectionsPagination__nav-section BaseSectionsPagination__nav-section--previous"  *ngIf="num>0" style="width: 350px;height: 75px;" (click)="changeNum(-1)">
            <div class="BaseSectionsPagination__nav-section-text">
              <span class="BaseSectionsPagination__nav-section-title" style="text-align: right;">{{i18n.t("js.check-lists.quest.Inspection")}}</span>
              <span class="BaseSectionsPagination__nav-section-name-container">
                <span class="BaseSectionsPagination__nav-section-index">{{num}}</span>
                <span class="BaseSectionsPagination__nav-section-name">{{data.check_list.check_list_metum.parts[num-1].title}}</span>
              </span>
            </div>
            <div class="ChecklistSectionsPagination__completion-status">
                <div class="ChecklistSectionsPagination__preview-counters" style="flex-direction: row-reverse;">
                  <span>{{data.check_list.check_list_metum.parts[num-1].count}}/{{getCount(data.check_list.check_list_metum.parts[num - 1].items)}}</span>
                  <svg style="transform: rotate(180deg);" t="1591001748506" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7718" width="24" height="14"><path d="M1010.80577 455.530292a29.72694 29.72694 0 0 1 0 42.037895L758.668226 749.785575a29.714963 29.714963 0 0 1-42.017934-42.027914l252.137544-252.227369a29.720951 29.720951 0 0 1 42.017934 0zM758.668226 203.312904l252.137544 252.217388a29.717957 29.717957 0 0 1-42.017934 42.037895l-252.137544-252.207407a29.721949 29.721949 0 0 1 42.017934-42.047876zM27.945419 447.20655h955.693411a20.460039 20.460039 0 0 1 20.460039 20.460039v18.254347a20.460039 20.460039 0 0 1-20.460039 20.460039H27.945419A20.460039 20.460039 0 0 1 7.48538 485.920936v-18.254347a20.460039 20.460039 0 0 1 20.460039-20.460039z" fill="#bcc9d1" p-id="7719"></path></svg>
                </div>
                <span class="jingdutiao-progress-bar">
                  <span class="jingdutiao-install-bar"  [style.width.%]="data.check_list.check_list_metum.parts[num-1].count/getCount(data.check_list.check_list_metum.parts[num - 1].items)*100"></span>
                </span>
            </div>
          </div>
        </div>
          <!-- 往后 -->
       <div style="width: 350px;">
        <div class="BaseSectionsPagination__nav-section BaseSectionsPagination__nav-section--next"  *ngIf="data.check_list.check_list_metum.parts.length != num+1"  (click)="changeNum(1)" style="width: 350px;height: 75px;">
          <div class="BaseSectionsPagination__nav-section-text">
            <span class="BaseSectionsPagination__nav-section-title">{{i18n.t("js.check-lists.quest.Response")}}</span>
            <span class="BaseSectionsPagination__nav-section-name-container">
              <span class="BaseSectionsPagination__nav-section-index">{{num+2}}</span>
              <span class="BaseSectionsPagination__nav-section-name">{{data.check_list.check_list_metum.parts[num+1].title}}</span>
            </span>
          </div>
          <div class="ChecklistSectionsPagination__completion-status">
              <div class="ChecklistSectionsPagination__preview-counters">
                <span>{{data.check_list.check_list_metum.parts[num+1].count}}/{{getCount(data.check_list.check_list_metum.parts[num + 1].items)}}</span>
                <svg t="1591001748506" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7718" width="24" height="14"><path d="M1010.80577 455.530292a29.72694 29.72694 0 0 1 0 42.037895L758.668226 749.785575a29.714963 29.714963 0 0 1-42.017934-42.027914l252.137544-252.227369a29.720951 29.720951 0 0 1 42.017934 0zM758.668226 203.312904l252.137544 252.217388a29.717957 29.717957 0 0 1-42.017934 42.037895l-252.137544-252.207407a29.721949 29.721949 0 0 1 42.017934-42.047876zM27.945419 447.20655h955.693411a20.460039 20.460039 0 0 1 20.460039 20.460039v18.254347a20.460039 20.460039 0 0 1-20.460039 20.460039H27.945419A20.460039 20.460039 0 0 1 7.48538 485.920936v-18.254347a20.460039 20.460039 0 0 1 20.460039-20.460039z" fill="#bcc9d1" p-id="7719"></path></svg>
              </div>
              <span class="jingdutiao-progress-bar">
                <span class="jingdutiao-install-bar"  [style.width.%]="data.check_list.check_list_metum.parts[num+1].count/getCount(data.check_list.check_list_metum.parts[num+1].items)*100"></span>
              </span>

          </div>
        </div>
      </div>

      </div>
    </div>
  </div>



  <i class="detailShow" (click)="detailClick(true)"><< </i>
  <div class="content-detailed">
    <div class="ChecklistPageRightPanel__header">
      <div class="ChecklistPageRightPanel__title">{{i18n.t("js.check-lists.quest.Details.Detailstext")}}</div>
      <button class="ChecklistPageRightPanel__close-button icon-close"  (click)="detailClick(false)"></button>
    </div>
    <div class="ChecklistPageRightPanel__counters">
      <div class="PreviewCountersIconLabel">
        <label class="IconLabel">
          <svg class="SvgIcon SvgIcon--store-icon" width="16px" height="16px">
            <use xlink:href="#sections" href="#sections"></use>
          </svg>
          <span class="IconLabel__value">{{arr_sum.length}}/{{data.check_list.check_list_metum.parts.length}} {{i18n.t("js.check-lists.quest.Details.Sections")}}</span>
        </label>
      </div>
      <div class="PreviewCountersIconLabel">
        <label class="IconLabel">
          <svg class="SvgIcon SvgIcon--store-icon" width="16px" height="16px">
            <use xlink:href="#sections" href="#sections"></use>
          </svg>
          <span class="IconLabel__value">{{sum}}/{{sum_num}} {{i18n.t("js.check-lists.quest.Details.Items")}}</span>
        </label>
      </div>
    </div>


    <hr class="B360Hr">
      <div class="Field--vertical">
        <label class=" Field__label">{{i18n.t("js.check-lists.quest.Details.Type")}}:</label>
        <div class="ChecklistPageRightPanel__editable-assignee">
          <!-- <input type="text" id="checklostsdate"> -->
          <div class="Editable__text">{{data.check_list.check_list_type&&data.check_list.check_list_type.name || i18n.t("js.check-lists.quest.Details.Unspecified")}}</div>
        </div>
      </div>
      <div class="Field--vertical">
        <label class=" Field__label">{{i18n.t("js.check-lists.quest.Details.Description")}}:</label>
        <div class="ChecklistPageRightPanel__editable-assignee">
          <div class="Editable__text">{{data.check_list.description || ''}}</div>
        </div>
      </div>
      <div class="Field--vertical">
        <label class=" Field__label">{{i18n.t("js.check-lists.quest.Details.number")}}:</label>
        <div class="ChecklistPageRightPanel__editable-assignee">
          <div class="Editable__text">{{data.check_list.no || ''}}</div>
        </div>
      </div>
      <div class="Field--vertical">
        <label class=" Field__label">{{i18n.t("js.check-lists.quest.Details.Signatures")}}:</label>
        <div class="ChecklistPageRightPanel__editable-assignee">
          <div class="Editable__text">{{count_doc.length}}/{{data.check_list.check_list_metum.signs.length}} {{i18n.t("js.check-lists.quest.Details.Signed")}} </div>
        </div>
      </div>
      <div *ngIf="isFileRefNo">
        <div  *ngIf="saveFileFlag">
          <hr class="B360Hr">
          <h3 style="padding: 5px 10px;" class="attributes-group--header-text">{{i18n.t("js.file-ref-no.title")}}</h3>
          <div class="Field--vertical">
            <label class=" Field__label">{{i18n.t("js.file-ref-no.prefix")}}:</label>
            <div class="ChecklistPageRightPanel__editable-assignee">
              <div class="Editable__text">{{ fileRefNo.prefix }}</div>
            </div>
          </div>
          <div class="Field--vertical">
            <label class=" Field__label">{{i18n.t("js.file-ref-no.id")}}:</label>
            <div class="ChecklistPageRightPanel__editable-assignee">
              <div class="Editable__text">-</div>
            </div>
          </div>
          <div class="Field--vertical">
            <label class=" Field__label">{{i18n.t("js.file-ref-no.type")}}:</label>
            <div class="ChecklistPageRightPanel__editable-assignee">
              <div class="Editable__text">
                <select class="attribute-fileRefNo-select" [(ngModel)]="fileRefNoType" [disabled]="!saveFileFlag?true:false">
                  <option  *ngFor="let item of fileRefNo.values; trackBy:trackByName" [value]="getStringValue(item.value)">
                  {{item.value.value}}
                  </option>
              </select>
              </div>
            </div>
          </div>
          <div class="Field--vertical">
            <label class=" Field__label">{{i18n.t("js.file-ref-no.suffix")}}:</label>
            <div class="ChecklistPageRightPanel__editable-assignee">
              <div class="Editable__text">-</div>
            </div>
          </div>
          <div  class="Field--vertical">
            <button accesskey="3" class="button -alt-highlight" (click)="saveFileRefNo()" >
              <op-icon class="op-icon--wrapper" icon-classes="button--icon icon-checkmark"><i aria-hidden="true"
                  class="button--icon icon-checkmark" title=""></i>
              </op-icon><span class="button--text">{{i18n.t("js.button_save")}}</span>
            </button>
          </div>
        </div>
        <div *ngIf="!saveFileFlag">
          <hr class="B360Hr">
          <h3 style="padding: 5px 10px;" class="attributes-group--header-text">{{i18n.t("js.file-ref-no.title")}}</h3>
          <div class="Field--vertical">
            <label class=" Field__label" *ngIf="data.check_list.file_ref_no">{{ data.check_list.file_ref_no }}</label>
          </div>
        </div>
      </div>
    <hr class="B360Hr">
    <div class="ChecklistPageRightPanel__subtitle" >{{i18n.t("js.check-lists.quest.Details.Createdby")}} {{data.check_list.created_by_user}}，{{detailsbottomtext}}</div>
  </div>
  <div class="editContent" *ngIf="showEditDiv">
    <div class="mainContent">
      <span class="closeIcon" (click)="closeBtn()"></span>
      <div class="imgContent">
        <div class="imgLine">
          <img  [ngClass]="{'imgLeftHeight':(imageLeftData.height > imageLeftData.width),imgLeft: (imageLeftData.height <= imageLeftData.width)}"  [src]="imageLeftData.src"/>
        </div>
        <div class="rightFont" >
          <p class="fontLine">
            <b>{{i18n.t("js.check-lists.list-title.status")}}:</b>
            <select  *ngIf="showEditDiv&&showimgEdit" [(ngModel)]="imageData.status" (change)="goEdit($event)">
              <option value="before">before</option>
              <option value="after">after</option>
            </select>
            <span *ngIf="showEditDiv&&!showimgEdit">{{imageData.status}}</span>
          </p>
          <p class="fontLine" *ngIf="imageData.status=='before'">
            <b>{{i18n.t("js.check-lists.quest.Details.Location")}}:</b>
            <span *ngIf="showEditDiv&&!showimgEdit">{{imageData.location}}</span>
            <input type="text" *ngIf="showEditDiv&&showimgEdit" [(ngModel)]="imageData.location">
          </p>
          <p class="fontLine" *ngIf="imageData.status=='before'">
            <b>GPS</b>
            <span>{{ i18n.t("js.check-lists.quest.Longitude") }}: -</span>
            <span>{{i18n.t("js.check-lists.quest.Latitude")}}: -</span>
          </p>
          <p class="fontLine" *ngIf="imageData.status=='before'">
            <b>Finding:</b>
            <span *ngIf="showEditDiv&&!showimgEdit">{{imageData.finding}}</span>
            <input type="text"  *ngIf="showEditDiv&&showimgEdit"  [(ngModel)]="imageData.finding">
          </p>
          <p class="fontLine" *ngIf="imageData.status=='after'">
            <b>Following Action Taken:</b>
            <span *ngIf="showEditDiv&&!showimgEdit">{{imageData.following_action_token}}</span>
            <input type="text" *ngIf="showEditDiv&&showimgEdit" [(ngModel)]="imageData.following_action_token">
          </p>
          <p class="fontLine">
            <b>Description:</b>
            <span *ngIf="showEditDiv&&!showimgEdit">{{imageData.remarks}}</span>
            <input type="text" *ngIf="showEditDiv&&showimgEdit" [(ngModel)]="imageData.remarks">
          </p>
        </div>
      </div>
        <div class="bottomBtn"
            *ngIf="!checkDisable()">
        <button class="editbtn deletebtn" (click)="goDelete()">{{i18n.t("js.check-lists.template.delete")}}</button>
        <button class="editbtn" (click)="showimgEdit=true" *ngIf="showEditDiv&&!showimgEdit">{{i18n.t("js.documents.edit")}}</button>
        <button class="editbtn confirmbtn" (click)="confirmEdit()" *ngIf="showEditDiv&&showimgEdit">{{i18n.t("js.documents.save")}}</button>
      </div>
    </div>
  </div>
</div>
<div class="wage" *ngIf="assigntLoading"></div>
<div class="SectionItem__loading loadingDiv" *ngIf="showLoading || assigntLoading">
  <div class="loading-indicator -compact">
    <div class="block-1"></div>
    <div class="block-2"></div>
    <div class="block-3"></div>
    <div class="block-4"></div>
    <div class="block-5"></div>
  </div>
</div>


<!-- pdf -->
<check_lists-pdf  *ngIf="!showPdfdownload" [saveRes]="saveRes" [jumpUrl]="jumpUrl"  (backstep)="backstep()"></check_lists-pdf>

<div class="show_banner" *ngIf="show_banner">
  <div class="banner">
    <span style="margin-top: 20px;">{{i18n.t("js.check-lists.quest.Allpartscomplete")}}</span>
    <div (click)="okTable()">
      <span>{{i18n.t("js.check-lists.quest.Completechecklist")}}</span>
    </div>
  </div>
</div>

<check_lists-autograph *ngIf="signShow" (closeView)="colseSign($event)"></check_lists-autograph>


<check_lists-issue (close)='issueclone()' *ngIf='issueblock' [payload]='payload' [schema]='schema' [userdata]='userData' [byuserdata]='byuserdata'></check_lists-issue>


